/**
 * @param {{ widgets?: Record<string, any> }} props
 */
export function IntegrationWidgetsPanel({ widgets }) {
  if (!widgets) return null;

  const { hosting, figma, google_analytics, se_ranking } = widgets;

  return (
    <div className="stat-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1rem' }}>
      {hosting?.url || hosting?.configured ? (
        <div className="auth-card flat">
          <h4 style={{ margin: '0 0 0.5rem' }}>Hosting</h4>
          {hosting.url ? (
            <a href={hosting.url} target="_blank" rel="noreferrer" className="muted small">
              {hosting.url}
            </a>
          ) : null}
          <p className="muted small" style={{ margin: '0.5rem 0 0' }}>
            {hosting.ok
              ? `HTTP ${hosting.status_code} · ${hosting.latency_ms}ms`
              : hosting.error || 'Unreachable'}
          </p>
        </div>
      ) : null}

      {figma?.url ? (
        <div className="auth-card flat">
          <h4 style={{ margin: '0 0 0.5rem' }}>Figma</h4>
          <a href={figma.url} target="_blank" rel="noreferrer">
            {figma.name || 'Open file'}
          </a>
          {figma.last_modified ? <div className="muted small">Updated {figma.last_modified}</div> : null}
          {figma.error && !figma.ok ? <div className="muted small">{figma.error}</div> : null}
        </div>
      ) : null}

      {google_analytics?.url || google_analytics?.configured ? (
        <div className="auth-card flat">
          <h4 style={{ margin: '0 0 0.5rem' }}>Google Analytics</h4>
          {google_analytics.ok ? (
            <p className="muted small" style={{ margin: 0 }}>
              {google_analytics.sessions_7d ?? '—'} sessions · {google_analytics.users_7d ?? '—'} users (7d)
            </p>
          ) : (
            <p className="muted small">{google_analytics.error || 'No data'}</p>
          )}
          {google_analytics.url ? (
            <a href={google_analytics.url} target="_blank" rel="noreferrer" className="small">
              Open GA
            </a>
          ) : null}
        </div>
      ) : null}

      {se_ranking?.url || se_ranking?.configured ? (
        <div className="auth-card flat">
          <h4 style={{ margin: '0 0 0.5rem' }}>SE Ranking</h4>
          {se_ranking.ok ? (
            <p className="muted small" style={{ margin: 0 }}>
              Visibility {se_ranking.visibility ?? '—'}% · {se_ranking.keywords ?? '—'} keywords
            </p>
          ) : (
            <p className="muted small">{se_ranking.error || 'No data'}</p>
          )}
          {se_ranking.url ? (
            <a href={se_ranking.url} target="_blank" rel="noreferrer" className="small">
              Open SE Ranking
            </a>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
